export default "__VITE_ASSET__BrvhcGei__"